export const UNASSIGNED_FILTER = "__unassigned__";

export type AssignmentThread = {
  assignedComercial?: string | null;
  assignedOperaciones?: string | null;
  assignedComerciales?: string[];
};

const present = (value?: string | null): boolean => !!String(value || "").trim();

export const matchesAssignmentFilter = (
  thread: AssignmentThread,
  filter: string
): boolean => {
  if (!filter) return true;
  if (filter === UNASSIGNED_FILTER) {
    return !present(thread.assignedComercial) &&
      !(Array.isArray(thread.assignedComerciales) && thread.assignedComerciales.some(present));
  }
  return thread.assignedComercial === filter ||
    thread.assignedOperaciones === filter ||
    (Array.isArray(thread.assignedComerciales) && thread.assignedComerciales.includes(filter));
};
